module.exports = __webpack_public_path__ + "static/creative-bg-15f83b18fc4ca68d3ca0e335434aca21.jpg";